import { CoursePageLayout } from "../courseBlocks";
import { mathMenuData } from "../../../data/SubjectMenu/mathMenuData";
import { mathsImg } from "../../../data/SubjectContent/maths/img";
import { mathsDisplayBlocks } from "../../../data/SubjectContent/maths/display";

export function PageMathsDisplay() {
    return (
        <CoursePageLayout
            title="數學科 | 學生成果展示"
            subtitle="STUDENT DISPLAYS OF WORK"
            menuData={mathMenuData}
            nowIndex={3}
            topImage={{ src: mathsImg.displayTop }}
            blocks={mathsDisplayBlocks}
        />
    );
}
